import React from "react";
import Sidenav from "./components/Sidenav";
import Report from "./components/dashboardbox";

function AdminHome( ) {
  return (
    <div className="flex  ">
       <div className="">
       <Sidenav />
       </div>
        <div className="ml-6 md:ml-16 lg:w-full">
            <Report />
        </div>
    </div>
  );
}

export default AdminHome;
